import { useRouter } from 'next/router';

import type { AsideNavigationType } from '../components/layout/navigation/asideNavigation/asideNavigation';

import { PathNames } from '../constants/routingPath';

export const useMenuType = (): AsideNavigationType | undefined => {
  const router = useRouter();

  const path = router.pathname.includes('[')
    ? router.pathname.substring(0, router.pathname.indexOf('/['))
    : router.pathname;

  const matchedKey = Object.keys(PathNames).find((key) => PathNames[key].includes(path));

  if (matchedKey?.startsWith('COMPANY')) return 'company';
  if (matchedKey?.startsWith('TALENT')) return 'talent';
  if (matchedKey?.startsWith('ADMIN') || matchedKey?.startsWith('IMPERSONATE')) return 'admin';
  return undefined;
};
